import { message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form, ModalItem, FormItem, ButtonItem,
  InputItem, InputNumberItem, DatePickerItem, ErrorItem, TablaEditor
} from "../../../../Components/Items";
import moment from "moment";

const COLUMNAS_FIJAS = [
  { nombre: "Antigüedad", tipo: "numero" },
  { nombre: "Días Vacaciones", tipo: "numero" },
  { nombre: "Porc. Prima Vacacional", tipo: "numero" },
  { nombre: "Días Aguinaldo", tipo: "numero" },
  { nombre: "Factor Integración", tipo: "numero" },
  { nombre: "Días Antigüedad", tipo: "numero" },
];

class EditarTipoPrestacion extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    visible: this.props.visible,
    filas: [],
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.setState({ visible: this.props.visible });
      if (this.props.visible && this.props.tipoPrestacionId) {
        this.formRef.current && this.formRef.current.resetFields();
        this.setState({ filas: [] });
        this.consultarDatos(this.props.tipoPrestacionId);
      }
    }
  }

  onFinishFailed(e) { ErrorItem(e); }

  consultarDatos(id) {
    this.setState({ loading: true });
    axios
      .post(
        "tiposPrestaciones/datosTipoPrestacion",
        { tipoPrestacionId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          message.error("No se encontraron los datos del tipo de prestación");
        } else {
          const { nombre, nombreFormula, descripcion, ejercicio, fechaInicioVigencia, fechaFinVigencia, filas } = res.data.data;
          const filasConKey = (filas || []).map((f, i) => ({ ...f, key: i }));
          this.setState({ filas: filasConKey });
          this.formRef.current && this.formRef.current.setFieldsValue({
            nombre, nombreFormula, descripcion, ejercicio,
            fechaInicioVigencia: fechaInicioVigencia ? moment(fechaInicioVigencia) : undefined,
            fechaFinVigencia: fechaFinVigencia ? moment(fechaFinVigencia) : undefined,
          });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  }

  onEditorChange({ filas }) {
    this.setState({ filas });
  }

  onFinish(values) {
    const filas = this.state.filas.map(({ key, ...f }) => f);
    this.setState({ loading: true });
    axios
      .post(
        "tiposPrestaciones/editarTipoPrestacion",
        {
          ...values,
          filas,
          tipoPrestacionId: this.props.tipoPrestacionId,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Tipo de prestación actualizado exitosamente");
          this.cerrarModal();
        } else {
          message.error("No se pudo actualizar el tipo de prestación");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  }

  cerrarModal = () => {
    this.props.cerrarEditarTipoPrestacion();
    if (this.formRef.current) this.formRef.current.resetFields();
    this.setState({ filas: [] });
  };

  render() {
    return (
      <ModalItem
        title="Editar Tipo de Prestación"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarModal}
        width={900}
      >
        <Form
          ref={this.formRef}
          name="modalEditarTipoPrestacion"
          layout
          bottom={
            <ButtonItem type="primary" htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
              loading={this.state.loading}>
              Guardar
            </ButtonItem>
          }
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormItem name="nombre" label="Nombre" required margin>
            <InputItem placeholder="Ej: Prestaciones Mínimas de Ley 2024" />
          </FormItem>

          <FormItem name="nombreFormula" label="Nombre Fórmula" margin
            tooltip="Sin espacios ni caracteres especiales. Ej: prestMinLey2024">
            <InputItem
              placeholder="Ej: prestMinLey2024"
              style={{ fontFamily: "monospace" }}
              onChange={(e) => {
                const limpio = e.target.value.replace(/[^a-zA-Z0-9_]/g, "");
                this.formRef.current.setFieldsValue({ nombreFormula: limpio });
              }}
            />
          </FormItem>

          <FormItem name="descripcion" label="Descripción" margin>
            <InputItem placeholder="Descripción opcional" />
          </FormItem>

          <FormItem name="ejercicio" label="Ejercicio" margin>
            <InputNumberItem placeholder="Ej. 2024" min={2000} max={2100} />
          </FormItem>

          <FormItem name="fechaInicioVigencia" label="Inicio de Vigencia" margin>
            <DatePickerItem placeholder="Informativo" style={{ width: "100%" }} />
          </FormItem>

          <FormItem name="fechaFinVigencia" label="Fin de Vigencia" margin>
            <DatePickerItem placeholder="Informativo" style={{ width: "100%" }} />
          </FormItem>
        </Form>

        <div style={{ marginTop: 16 }}>
          <TablaEditor
            columnas={COLUMNAS_FIJAS}
            filas={this.state.filas}
            onChange={this.onEditorChange.bind(this)}
            columnasFijas
          />
        </div>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(EditarTipoPrestacion);